export const verticalDotsIconSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12.5" cy="6.5" r="1.5" fill="#3871FF"/>
<circle cx="12.5" cy="18.5" r="1.5" fill="#3871FF"/>
<circle cx="12.5" cy="12.5" r="1.5" fill="#3871FF"/>
</svg>`

const VerticalDotsIcon = ({ size = 24, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx="12.5" cy="6.5" r="1.5" fill={color} />
            <circle cx="12.5" cy="18.5" r="1.5" fill={color} />
            <circle cx="12.5" cy="12.5" r="1.5" fill={color} />
        </svg>
    )
}

export default VerticalDotsIcon
